import AppConstants from '../../Constants/AppConstants';

const keyFor = (type, id) =>
  `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:/listing-category:description-translation:${type || 'category'}:${id || 'new'}`;

const safeValues = values => (Array.isArray(values) ? values : []).slice(0, 100).map(item => ({
  locale: typeof item?.locale === 'string' ? item.locale.slice(0, 20) : '',
  value: typeof item?.value === 'string' ? item.value.slice(0, 20000) : '',
})).filter(item => item.locale);

export const readDescriptionTranslationDraft = (type, id) => {
  if (typeof window === 'undefined') return [];
  try {
    return safeValues(JSON.parse(window.localStorage.getItem(keyFor(type, id)) || '[]'));
  } catch (error) {
    return [];
  }
};

export const writeDescriptionTranslationDraft = (type, id, values) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(keyFor(type, id), JSON.stringify(safeValues(values)));
  } catch (error) {
    // Keep the translation editor usable if browser storage is unavailable.
  }
};

export const clearDescriptionTranslationDraft = (type, id) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(keyFor(type, id));
  } catch (error) {
    // Ignore storage errors after a successful save.
  }
};
